import $api from "@/api";
import {
  RaffleBonusInitResponse,
  RaffleHistoryResponse,
  RaffleInitResponse,
} from "@/apps/raffle/types";

export const requestRaffleBonusInit = async (yandexId: string) => {
  const { data } = await $api.get<RaffleBonusInitResponse>(
    "/personal-goal/bonus/init/",
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data;
};

export const requestRaffleInit = async (yandexId: string) => {
  const data = await requestRaffleBonusInit(yandexId);

  return data.current_draw;
};

export const requestRaffleById = async (bonusId: string, yandexId: string) => {
  const { data } = await $api.get<RaffleInitResponse>(
    `/personal-goal/bonus/${bonusId}/`,
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data;
};

export const requestRaffleHistory = async (yandexId: string) => {
  const { data } = await $api.get<RaffleHistoryResponse>(
    "/personal-goal/bonus/",
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data;
};

export const requestRaffleClaim = async (yandexId: string) => {
  const { data } = await $api.post("/personal-goal/bonus/claim/", null, {
    params: {
      yandex_id: yandexId,
    },
  });

  return data;
};

export const requestRafflePopupSeen = async (
  yandexId: string,
  drawId: number
) => {
  const { data } = await $api.post(
    "/personal-goal/bonus/popup-seen/",
    {
      draw_id: drawId,
    },
    {
      params: {
        yandex_id: yandexId,
      },
    }
  );

  return data;
};
